import { render } from "./FooterClasicos.vue?vue&type=template&id=26c1347a&scoped=true"
import script from "./FooterClasicos.vue?vue&type=script&lang=js"
export * from "./FooterClasicos.vue?vue&type=script&lang=js"

import "./FooterClasicos.vue?vue&type=style&index=0&id=26c1347a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c1347a"]])

export default __exports__